/*
Double Tap to Go
Authors: Osvaldas Valutis (www.osvaldas.info), Graffino (http://www.graffino.com), Tribal Systems
Available for use under the MIT License
*/
!function(n){var t,o;n(document).on("click touchstart MSPointerDown",function(){t=o,o=void 0}),n.fn.doubleTapToGo=function(){return!!("ontouchstart"in window||navigator.msMaxTouchPoints)&&(this.each(function(){n(this).on("click",function(i){var c=n(this);c[0]!=t&&(i.preventDefault(),setTimeout(function(){t=o=c[0]},1))})}),this)}}(jQuery);
